export const UMMELDUNG_EXIT_POPUP_RESULT = {
  saveAndExit: 'SAVE_AND_EXIT',
  discardAndExit: 'DISCARD_AND_EXIT',
  stay: 'STAY',
} as const;

export type UmmeldungExitPopupDecision = (typeof UMMELDUNG_EXIT_POPUP_RESULT)[keyof typeof UMMELDUNG_EXIT_POPUP_RESULT];

export function mapExitPopupResultToDecision(result: unknown): UmmeldungExitPopupDecision {
  if (result === UMMELDUNG_EXIT_POPUP_RESULT.saveAndExit || result === UMMELDUNG_EXIT_POPUP_RESULT.discardAndExit) {
    return result;
  }
  return UMMELDUNG_EXIT_POPUP_RESULT.stay;
}
